(function () {
  'use strict';

  if (window.__MOD_HELIX_NATIVE_VARIANTS__) return;
  window.__MOD_HELIX_NATIVE_VARIANTS__ = true;

  var initializedRoots = new WeakSet();

  function parseJson(root, selector, fallback) {
    var node = root.querySelector(selector);
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || '');
    } catch (_) {
      return fallback;
    }
  }

  function normalize(value) {
    return String(value == null ? '' : value).trim();
  }

  function optionValue(variant, position) {
    if (!variant || !position) return '';
    if (Array.isArray(variant.options)) return normalize(variant.options[position - 1]);
    return normalize(variant['option' + position]);
  }

  function money(cents) {
    var value = Number(cents || 0);
    var hasCents = Math.abs(value % 100) > 0;
    return (value / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  function uniqueOptionControls(root) {
    return Array.from(root.querySelectorAll('[data-helix-option-position]')).filter(function (control) {
      return control instanceof HTMLInputElement || control instanceof HTMLSelectElement;
    });
  }

  function initRoot(root) {
    if (!(root instanceof HTMLElement) || initializedRoots.has(root)) return;

    var variants = parseJson(root, '[data-helix-variants-json]', []);
    if (!Array.isArray(variants) || variants.length === 0) return;

    var nativeReady = root.dataset.helixNativeReady === 'true';
    var presentation = root.dataset.helixPresentation || 'default';
    var section = root.closest('section') || root.parentElement || document;
    var productButtonGroup = section.querySelector('.product-button-group');
    var form =
      root.closest('form[action*="/cart/add"]') ||
      root.querySelector('form[action*="/cart/add"]') ||
      (productButtonGroup && productButtonGroup.closest('form[action*="/cart/add"]')) ||
      section.querySelector('form[action*="/cart/add"]');
    if (!(form instanceof HTMLFormElement)) return;

    var variantInput = form.querySelector('input[name="id"]');
    var addButton = form.querySelector('button[type="submit"]');
    if (!(variantInput instanceof HTMLInputElement) || !(addButton instanceof HTMLButtonElement)) return;
    initializedRoots.add(root);

    var controls = uniqueOptionControls(root);
    var migrationControls = Array.from(root.querySelectorAll('[data-helix-migration-option] input[type="radio"]'));
    var currentVariantId = normalize(root.dataset.helixCurrentVariantId || variantInput.value);
    var currentVariant = variants.find(function (variant) {
      return String(variant.id) === currentVariantId;
    }) || variants[0];
    var selectedOptions = Array.isArray(currentVariant.options) ? currentVariant.options.slice() : [];
    var validVariant = currentVariant;
    var originalButtonText = addButton.textContent.trim();

    function controlsForPosition(position) {
      return controls.filter(function (control) {
        return Number(control.dataset.helixOptionPosition) === Number(position);
      });
    }

    function positions() {
      return Array.from(new Set(controls.map(function (control) {
        return Number(control.dataset.helixOptionPosition);
      }).filter(Boolean))).sort(function (a, b) { return a - b; });
    }

    function selectedControlValue(position) {
      var group = controlsForPosition(position);
      if (group.length === 0) return '';
      var select = group.find(function (control) { return control instanceof HTMLSelectElement; });
      if (select) return normalize(select.value);
      var checked = group.find(function (control) {
        return control instanceof HTMLInputElement && control.checked;
      });
      return checked ? normalize(checked.value) : '';
    }

    function readSelectedOptions() {
      var next = selectedOptions.slice();
      positions().forEach(function (position) {
        next[position - 1] = selectedControlValue(position);
      });
      return next;
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return options.every(function (value, index) {
          return normalize(variant.options && variant.options[index]) === normalize(value);
        });
      });
    }

    function setControlSelection(options) {
      controls.forEach(function (control) {
        var position = Number(control.dataset.helixOptionPosition);
        var value = normalize(options[position - 1]);
        if (control instanceof HTMLSelectElement) {
          control.value = value;
        } else if (control instanceof HTMLInputElement) {
          control.checked = normalize(control.value) === value;
        }
      });
    }

    function updateSelectedLabels(options) {
      root.querySelectorAll('[data-helix-selected-value]').forEach(function (label) {
        var position = Number(label.dataset.helixSelectedValue);
        label.textContent = normalize(options[position - 1]);
      });

      controls.forEach(function (control) {
        if (!(control instanceof HTMLInputElement)) return;
        var item = control.closest('.size-detail-item, .helix-lux-pdp__upgrade-card');
        if (!item) return;
        item.classList.toggle('active', control.checked);
        item.classList.toggle('is-selected', control.checked);
      });
    }

    function updateProperties(options) {
      var coolingPosition = Number(root.dataset.helixCoolingPosition || 0);
      var supportPosition = Number(root.dataset.helixSupportPosition || 0);
      var coolingProperty = form.querySelector('input[name="properties[Cooling]"]');
      var supportProperty = form.querySelector('input[name="properties[Support]"]');
      if (coolingProperty && coolingPosition) coolingProperty.value = normalize(options[coolingPosition - 1]);
      if (supportProperty && supportPosition) supportProperty.value = normalize(options[supportPosition - 1]);
    }

    function updateThirdPartyVariantState(variant) {
      if (!variant || !variant.id) return;
      try {
        var protection = (window.TH_GLOBAL || {}).productProtectionOptions;
        var protectionVariants = protection && protection.product && Array.isArray(protection.product.variants)
          ? protection.product.variants
          : [];
        var protectionMatch = protectionVariants.find(function (candidate) {
          return Number(candidate.id) === Number(variant.id);
        });
        if (protection && protectionMatch) protection.currentVariant = protectionMatch;

        var snapId = document.getElementById('variant-id-snap');
        if (snapId instanceof HTMLInputElement) snapId.value = String(variant.id);
        var snapInfo = document.getElementById('product-info-snap');
        if (snapInfo instanceof HTMLElement) snapInfo.dataset.variantId = String(variant.id);
      } catch (_) {}
    }

    function announceVariant(variant) {
      if (!variant) return;
      var detail = { variant: variant, source: 'helix-native-picker' };
      root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: detail }));
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.variantChange, { data: detail });
        }
      } catch (_) {}
    }

    function updateUrl(variant) {
      if (!variant || !variant.id || !window.history || !window.URL) return;
      try {
        var url = new URL(window.location.href);
        if (url.searchParams.get('variant') === String(variant.id)) return;
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (_) {}
    }

    function updateImage(variant) {
      if (presentation !== 'luxe' || !variant) return;
      var image = variant.featured_image || (variant.featured_media && variant.featured_media.preview_image);
      var src = image && (image.src || image.url);
      if (!src) return;
      var target = root.querySelector('.helix-lux-pdp__main-image img');
      if (!(target instanceof HTMLImageElement)) return;
      target.src = src;
      if (image.alt) target.alt = image.alt;
    }

    function updateDimensions(options) {
      if (presentation !== 'luxe') return;
      var target = root.querySelector('[data-helix-dimensions]');
      var sizePosition = Number(root.dataset.helixSizePosition || 1);
      if (!target) return;
      var key = normalize(options[sizePosition - 1]).toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ');
      var dimensions = {
        'twin': '38 in W × 75 in L × 13.5 in H',
        'twin xl': '38 in W × 80 in L × 13.5 in H',
        'full': '54 in W × 75 in L × 13.5 in H',
        'queen': '60 in W × 80 in L × 13.5 in H',
        'king': '76 in W × 80 in L × 13.5 in H',
        'cal king': '72 in W × 84 in L × 13.5 in H',
        'ca king': '72 in W × 84 in L × 13.5 in H',
        'california king': '72 in W × 84 in L × 13.5 in H',
        'short queen': '60 in W × 74 in L × 13.5 in H',
        'short queen 60x74': '60 in W × 74 in L × 13.5 in H',
        'short rv queen 60x74': '60 in W × 74 in L × 13.5 in H',
        'rv king': '72 in W × 80 in L × 13.5 in H',
        'rv king 72x80': '72 in W × 80 in L × 13.5 in H',
        'rv king 74x80': '72 in W × 80 in L × 13.5 in H'
      };
      if (dimensions[key]) target.textContent = dimensions[key];
    }

    function updatePrice(variant) {
      if (!variant) return;
      var price = Number(variant.price || 0);
      var compareAt = Number(variant.compare_at_price || 0);
      var scope = section instanceof Element ? section : root;

      var priceTarget = root.querySelector('[data-helix-current-price]') || scope.querySelector('.total-price');
      if (priceTarget) priceTarget.textContent = money(price);

      var cartPrice = root.querySelector('[data-helix-cart-price]');
      if (cartPrice) {
        cartPrice.textContent = money(price);
        cartPrice.hidden = false;
      }

      var compareTarget = root.querySelector('[data-helix-compare-price]') || scope.querySelector('.total-price-compare');
      if (compareTarget) {
        compareTarget.textContent = compareAt > price ? money(compareAt) : '';
        compareTarget.hidden = !(compareAt > price);
      }

      var savings = scope.querySelector('.price-savings');
      var savingsAmount = scope.querySelector('.savings-amount');
      var savingsPercent = scope.querySelector('.savings-percent');
      if (savings) savings.style.display = compareAt > price ? 'block' : 'none';
      if (compareAt > price && savingsAmount) savingsAmount.textContent = 'Save ' + money(compareAt - price);
      if (compareAt > price && savingsPercent) {
        savingsPercent.textContent = '(' + Math.round(((compareAt - price) / compareAt) * 100) + '% off)';
      }

      var luxeDiscount = root.querySelector('[data-helix-discount]');
      var luxeDiscountPercent = root.querySelector('[data-helix-discount-percent]');
      if (luxeDiscount) luxeDiscount.hidden = !(compareAt > price);
      if (compareAt > price && luxeDiscountPercent) {
        luxeDiscountPercent.textContent = Math.round(((compareAt - price) / compareAt) * 100) + '% off';
      }

      var monthly = root.querySelector('[data-helix-monthly-price]');
      if (monthly) monthly.textContent = '$' + Math.ceil(price / 100 / 24);
    }

    function setButtonState(state, variant) {
      var status = root.querySelector('[data-helix-add-status]');
      var cartPrice = root.querySelector('[data-helix-cart-price]');
      var delivery = section.querySelector('.product-delivery p');
      var enabled = state === 'available';
      addButton.disabled = !enabled;
      addButton.setAttribute('aria-disabled', enabled ? 'false' : 'true');

      if (presentation === 'luxe') {
        if (status) {
          status.textContent = enabled
            ? 'Add to Cart —'
            : state === 'sold-out'
              ? 'Sold Out'
              : state === 'migration'
                ? 'Configuration temporarily unavailable'
                : 'Unavailable';
        }
        if (cartPrice) cartPrice.hidden = !enabled;
      } else {
        addButton.textContent = enabled
          ? originalButtonText
          : state === 'sold-out'
            ? 'Sold Out'
            : 'Unavailable';
      }

      if (delivery) delivery.textContent = enabled ? 'In stock' : 'Out of stock';
      root.dataset.helixValidVariant = enabled && variant ? 'true' : 'false';
    }

    function syncVariant(variant, options, shouldUpdateUrl) {
      validVariant = variant || null;
      selectedOptions = options.slice();
      updateSelectedLabels(options);
      updateProperties(options);
      updateDimensions(options);

      if (!variant) {
        variantInput.value = '';
        root.dataset.helixSelectedVariantId = '';
        root.dataset.helixSelectedSku = '';
        setButtonState('unavailable', null);
        return;
      }

      updatePrice(variant);
      updateImage(variant);
      root.dataset.helixSelectedVariantId = String(variant.id || '');
      root.dataset.helixSelectedSku = normalize(variant.sku);
      variantInput.value = String(variant.id || '');
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      updateThirdPartyVariantState(variant);
      setButtonState(variant.available ? 'available' : 'sold-out', variant);
      if (shouldUpdateUrl) updateUrl(variant);
      announceVariant(variant);
    }

    function candidateAvailable(position, candidateValue, options) {
      return variants.some(function (variant) {
        if (!variant.available) return false;
        return options.every(function (value, index) {
          if (index === position - 1) return normalize(variant.options[index]) === normalize(candidateValue);
          return normalize(variant.options[index]) === normalize(value);
        });
      });
    }

    function syncAvailability(options) {
      positions().forEach(function (position) {
        controlsForPosition(position).forEach(function (control) {
          if (control instanceof HTMLSelectElement) {
            Array.from(control.options).forEach(function (option) {
              option.disabled = !candidateAvailable(position, option.value, options);
            });
            return;
          }
          if (!(control instanceof HTMLInputElement)) return;
          var available = candidateAvailable(position, control.value, options);
          control.disabled = !available;
          var card = control.closest('.size-detail-item, .helix-lux-pdp__upgrade-card');
          if (card) card.classList.toggle('is-unavailable', !available);
        });
      });
    }

    function baselineValue(position) {
      var group = controlsForPosition(position);
      if (group.length === 0) return '';
      var select = group.find(function (control) { return control instanceof HTMLSelectElement; });
      if (select && select.options.length) return normalize(select.options[0].value);
      return normalize(group[0].value);
    }

    function updateDeltas(options) {
      var deltaTargets = Array.prototype.slice.call(root.querySelectorAll('[data-helix-option-delta]'));
      document.querySelectorAll('.helix-modal [data-helix-option-delta]').forEach(function (target) {
        if (deltaTargets.indexOf(target) === -1) deltaTargets.push(target);
      });

      deltaTargets.forEach(function (target) {
        var position = Number(target.dataset.helixOptionPosition || 0);
        var value = normalize(target.dataset.helixOptionValue);
        if (!position || !value) return;
        var baseOptions = options.slice();
        var candidateOptions = options.slice();
        baseOptions[position - 1] = baselineValue(position);
        candidateOptions[position - 1] = value;
        var baseVariant = findVariant(baseOptions);
        var candidateVariant = findVariant(candidateOptions);
        if (!baseVariant || !candidateVariant) {
          target.textContent = '';
          return;
        }
        var delta = Number(candidateVariant.price || 0) - Number(baseVariant.price || 0);
        target.textContent = delta === 0 ? '+$0' : (delta > 0 ? '+' : '−') + money(Math.abs(delta));
      });
    }

    function syncNative(shouldUpdateUrl) {
      var options = readSelectedOptions();
      var variant = findVariant(options);
      syncAvailability(options);
      updateDeltas(options);
      syncVariant(variant, options, shouldUpdateUrl);
    }

    function checkedMigrationIsPaid() {
      return migrationControls.some(function (control) {
        return control.checked && control.dataset.helixMigrationPaid === 'true';
      });
    }

    function updateMigrationSelection() {
      migrationControls.forEach(function (control) {
        var card = control.closest('.helix-lux-pdp__upgrade-card');
        if (card) card.classList.toggle('is-selected', control.checked);
        if (!control.checked) return;
        var propertyName = control.dataset.helixMigrationProperty;
        var property = propertyName
          ? form.querySelector('input[name="properties[' + propertyName + ']"]')
          : null;
        if (property) property.value = control.value;
      });
    }

    function syncFallback(shouldUpdateUrl) {
      var options = readSelectedOptions();
      var variant = findVariant(options);
      updateMigrationSelection();
      updateSelectedLabels(options);
      updateDimensions(options);
      if (variant) updatePrice(variant);

      var migrationMessage = root.querySelector('[data-helix-migration-message]');
      var paidChoice = checkedMigrationIsPaid();
      if (migrationMessage) migrationMessage.hidden = !paidChoice;
      if (paidChoice) {
        validVariant = null;
        variantInput.value = '';
        setButtonState('migration', null);
        return;
      }
      syncVariant(variant, options, shouldUpdateUrl);
    }

    controls.forEach(function (control) {
      control.addEventListener('change', function () {
        if (control instanceof HTMLInputElement && !control.checked) return;
        var details = control.closest('details');
        if (details) details.open = false;
        if (nativeReady) syncNative(true);
        else syncFallback(true);
      });
    });

    migrationControls.forEach(function (control) {
      control.addEventListener('change', function () {
        if (control.checked) syncFallback(false);
      });
    });

    form.addEventListener('submit', function (event) {
      if (nativeReady) syncNative(false);
      else syncFallback(false);
      if (!validVariant || !validVariant.available || !variantInput.value) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    var initialOptions = selectedOptions.slice();
    setControlSelection(initialOptions);
    if (nativeReady) syncNative(false);
    else syncFallback(false);
    root.dataset.helixControllerReady = 'true';
    addButton.removeAttribute('data-helix-awaiting-init');
    var initMessage = root.querySelector('[data-helix-init-message]');
    if (initMessage) initMessage.hidden = true;
  }

  function initAll() {
    document.querySelectorAll('[data-helix-native-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
